import SupplierProductAdminMenu from './SupplierProductAdminMenu'

export default SupplierProductAdminMenu
